<template lang="html">

    <section class="src-components-header">
        <b-navbar toggleable="lg" type="light" variant="light" v-if="show">
            <b-navbar-brand>Admin</b-navbar-brand>

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav>
                    <router-link class="nav-link" to="/home/users">Користувачі</router-link>
                    <router-link class="nav-link" to="/home/managers">Менеджери</router-link>
                    <router-link class="nav-link" to="/home/notifications">Розсилка</router-link>
                    <router-link class="nav-link" to="/home/prices">Ціни</router-link>
                    <router-link class="nav-link" to="/home/stat">Статистика</router-link>
                    <router-link class="nav-link" to="/home/options">Налаштування</router-link>
                    <b-button variant="primary" class="nav-link button" @click="logOut()" v-if="isAuth()">Вийти</b-button>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
    </section>

</template>

<script lang="js">

export default {
        name: 'src-components-header',
        props: [],
        mounted() {

        },
        data() {
            return {
                show: true
            }
        },
        methods: {
            isAuth() {
                return !!localStorage.getItem('token');
            },
            logOut() {
                localStorage.removeItem('token');
                this.$router.push('/');
                this.rerender();
            },
            rerender() {
                this.show = false;
                this.$nextTick(() => {
                    this.show = true;
                })
            },
        },
        computed: {}
    }
</script>

<style lang="scss">
    .src-components-header {
        .button, .button:active, .button:focus {
            background-color: transparent !important;
            border-color: transparent !important;
            outline: none !important;
        }
    }
</style>
